module.exports = __webpack_public_path__ + "media/images/icon-cake-4038fc909e8ac6fb317a3c013b408f4d.png";